import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { Identification } from './components/Identification';
import { EmotionalHook } from './components/EmotionalHook';
import { TraditionalMethods } from './components/TraditionalMethods';
import { Mechanism } from './components/Mechanism';
import { ProductReveal } from './components/ProductReveal';
import { WhatsInside } from './components/WhatsInside';
import { Benefits } from './components/Benefits';
import { BeforeAfter } from './components/BeforeAfter';
import { Testimonials } from './components/Testimonials';
import { Credibility } from './components/Credibility';
import { ValueStack } from './components/ValueStack';
import { RiskReversal } from './components/RiskReversal';
import { Urgency } from './components/Urgency';
import { DecisionTable } from './components/DecisionTable';
import { PrimaryCTA } from './components/PrimaryCTA';
import { EmotionalClose } from './components/EmotionalClose';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-white font-sans selection:bg-coral-light selection:text-ink" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Hero data-id="element-2" />
      <Identification data-id="element-3" />
      <EmotionalHook data-id="element-4" />
      <TraditionalMethods data-id="element-5" />
      <Mechanism data-id="element-6" />
      <ProductReveal data-id="element-7" />
      <WhatsInside data-id="element-8" />
      <Benefits data-id="element-9" />
      <BeforeAfter data-id="element-10" />
      <Testimonials data-id="element-11" />
      <Credibility data-id="element-12" />
      <ValueStack data-id="element-13" />
      <RiskReversal data-id="element-14" />
      <Urgency data-id="element-15" />
      <DecisionTable data-id="element-16" />
      <PrimaryCTA data-id="element-17" />
      <EmotionalClose data-id="element-18" />
      <FAQ data-id="element-19" />
      <Footer data-id="element-20" />
      <StickyCTA data-id="element-21" />
    </main>;
}